import "../App.css";
import React from "react";

export default function Footer() {
  return (
    <footer className="text-center text-white bg-slate-100 dark:bg-gray-900">
      <div className="max-w-7xl mx-auto flex justify-center flex-row-1">
        <div className="my-auto flex flex-col mr-4 md:mr-5 relative">
          <img
            className="w-20 h-20 z-10"
            src="/favicon.png"
            alt="OMMCLogo-Footer"
            href="/"
          />
          <div className="absolute left-0 right-1/2  top-0 bottom-0 inset-0 opacity-[35%] dark:opacity-[40%] transform-gpu animate-blob1 rounded-full blur-2xl bg-red-700 "></div>
        </div>
        <div className="flex flex-col pt-11">
          <div className="flex justify-left mb-2 mt-2">
            <a
              href="https://www.youtube.com/channel/UCyphrZpMeuA1ATGPzlStsng"
              className="mr-9 text-gray-800 dark:text-[#ff0000] hover:text-[#ff0000] hover:scale-105 transform duration-150 ease-in-out"
            >
              <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fab"
                className="svg-inline--fa fa-youtube w-4 "
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 42 42"
              >
                <path
                  d="M20.2838235,29.7208546 L20.2817697,19.3775851 L30.0092421,24.5671906 L20.2838235,29.7208546 Z M41.6409276,17.5856462 C41.6409276,17.5856462 41.2890436,15.0488633 40.2097727,13.9319394 C38.8405739,12.4655276 37.3060444,12.4583393 36.6026186,12.3724221 C31.5649942,12 24.008044,12 24.008044,12 L23.9922983,12 C23.9922983,12 16.4356904,12 11.398066,12.3724221 C10.6939556,12.4583393 9.16045298,12.4655276 7.79091194,13.9319394 C6.71164104,15.0488633 6.36009927,17.5856462 6.36009927,17.5856462 C6.36009927,17.5856462 6,20.5646804 6,23.5437145 L6,26.3365376 C6,29.3152295 6.36009927,32.2946059 6.36009927,32.2946059 C6.36009927,32.2946059 6.71164104,34.8310466 7.79091194,35.9483127 C9.16045298,37.4147246 10.9592378,37.3681718 11.7605614,37.5218644 C14.6406709,37.8042616 24.0001711,37.8915481 24.0001711,37.8915481 C24.0001711,37.8915481 31.5649942,37.8799099 36.6026186,37.5074878 C37.3060444,37.4219129 38.8405739,37.4147246 40.2097727,35.9483127 C41.2890436,34.8310466 41.6409276,32.2946059 41.6409276,32.2946059 C41.6409276,32.2946059 42,29.3152295 42,26.3365376 L42,23.5437145 C42,20.5646804 41.6409276,17.5856462 41.6409276,17.5856462 L41.6409276,17.5856462 Z"
                  fill="currentColor"
                ></path>
              </svg>
            </a>
            <a
              href="https://twitter.com/officialommc"
              className="mr-9 text-gray-800 dark:text-[#1da1f2]  hover:text-[#1da1f2] hover:scale-105 transform duration-150 ease-in-out"
            >
              <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fab"
                data-icon="twitter"
                className="svg-inline--fa fa-twitter w-4"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
              >
                <path
                  fill="currentColor"
                  d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"
                ></path>
              </svg>
            </a>
            <a
              href="mailto:ommcofficial@gmail.com"
              className="group mr-9 text-gray-800 dark:text-gray-400 hover:scale-105 transform duration-150 ease-in-out "
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="52 42 88 66"
                className="svg-inline--fa fa-google w-3.5"
                height="16"
                width="16"
              >
                <path
                  className="group-hover:text-[#4285f4] dark:text-[#4285f4] transition duration-150 ease-out"
                  fill="currentColor"
                  d="M58 108h14V74L52 59v43c0 3.32 2.69 6 6 6"
                />
                <path
                  className="group-hover:text-[#34a853] dark:text-[#34a853] transition duration-150 ease-out"
                  fill="currentColor"
                  d="M120 108h14c3.32 0 6-2.69 6-6V59l-20 15"
                />
                <path
                  className="group-hover:text-[#fbbc04] dark:text-[#fbbc04] transition duration-150 ease-out"
                  fill="currentColor"
                  d="M120 48v26l20-15v-8c0-7.42-8.47-11.65-14.4-7.2"
                />
                <path
                  className="group-hover:text-[#ea4335] dark:text-[#ea4335] transition duration-150 ease-out"
                  fill="currentColor"
                  d="M72 74V48l24 18 24-18v26L96 92"
                />
                <path
                  className="group-hover:text-[#c5221f] dark:text-[#c5221f] transition duration-150 ease-out"
                  fill="currentColor"
                  d="M52 51v8l20 15V48l-5.6-4.2c-5.94-4.45-14.4-.22-14.4 7.2"
                />
              </svg>
            </a>

            <a
              href="https://www.instagram.com/ommcofficial/"
              className="mr-4 group text-gray-800 dark:text-gray-300 hover:scale-105 transform duration-150 ease-in-out"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                height="17.5"
                width="17.5"
                viewBox="-8.093805 -13.489675 70.14631 80.93805"
                className="absolute z-10 opacity-0 dark:opacity-100 group-hover:opacity-100 transition duration-150 ease-out"
              >
                <defs>
                  <linearGradient
                    id="a"
                    y2="1.7526"
                    x2="1.7537"
                    y1="-5.8041"
                    x1="-5.8093"
                  >
                    <stop offset="0%" stopColor="#FFD521" />
                    <stop offset="5%" stopColor="#FFD521" />
                    <stop offset="50.1119%" stopColor="#F50000" />
                    <stop offset="95%" stopColor="#B900B4" />
                    <stop offset="95.0079%" stopColor="#B900B4" />
                    <stop offset="100%" stopColor="#B900B4" />
                  </linearGradient>
                  <linearGradient
                    id="b"
                    y2=".9175"
                    x2=".9175"
                    y1=".0091"
                    x1=".009"
                  >
                    <stop offset="0%" stopColor="#FFD521" />
                    <stop offset="5%" stopColor="#FFD521" />
                    <stop offset="50.1119%" stopColor="#F50000" />
                    <stop offset="95%" stopColor="#B900B4" />
                    <stop offset="95.0079%" stopColor="#B900B4" />
                    <stop offset="100%" stopColor="#B900B4" />
                  </linearGradient>
                  <linearGradient
                    id="c"
                    y2="1.3128"
                    x2="1.3126"
                    y1="-.456"
                    x1="-.4558"
                  >
                    <stop offset="0%" stopColor="#FFD521" />
                    <stop offset="5%" stopColor="#FFD521" />
                    <stop offset="50.1119%" stopColor="#F50000" />
                    <stop offset="95%" stopColor="#B900B4" />
                    <stop offset="95.0079%" stopColor="#B900B4" />
                    <stop offset="100%" stopColor="#B900B4" />
                  </linearGradient>
                  <linearGradient
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="scale(1.00041 .99959)"
                    y2="11.412"
                    x2="11.3667"
                    y1="-37.5455"
                    x1="-37.6312"
                    id="d"
                    xlinkHref="#a"
                  />
                  <linearGradient
                    gradientUnits="userSpaceOnUse"
                    y2="49.554"
                    x2="49.5047"
                    y1=".536"
                    x1=".4867"
                    id="e"
                    xlinkHref="#b"
                  />
                  <linearGradient
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="scale(.99988 1.00012)"
                    y2="36.4816"
                    x2="36.4315"
                    y1="-12.5305"
                    x1="-12.5688"
                    id="f"
                    xlinkHref="#c"
                  />
                </defs>
                <g fill="none">
                  <path
                    d="M6.4867 3.292c0 1.7933-1.4534 3.2413-3.24 3.2413C1.46 6.5333.0053 5.0853.0053 3.292.0053 1.5053 1.46.0573 3.2467.0573c1.7866 0 3.24 1.448 3.24 3.2347"
                    fill="url(#d)"
                    transform="matrix(1 0 0 -1 38.1333 15.8707)"
                  />
                  <path
                    d="M48.9373 16.124c-.12-2.6307-.56-4.06-.9253-5.0093-.4907-1.2587-1.076-2.1587-2.0253-3.1027-.9387-.944-1.8387-1.528-3.0974-2.0133-.9493-.3707-2.384-.812-5.0146-.9374-2.844-.1253-3.6867-.152-10.8987-.152-7.2053 0-8.0547.0267-10.8987.152-2.6306.1254-4.0586.5667-5.008.9374C9.804 6.484 8.9107 7.068 7.9667 8.012c-.9507.944-1.536 1.844-2.02 3.1027-.3654.9493-.812 2.3786-.9254 5.0093-.1386 2.844-.164 3.7-.164 10.8973 0 7.212.0254 8.0614.164 10.9054.1134 2.6306.56 4.0586.9254 5.016.484 1.2573 1.0693 2.152 2.02 3.096.944.9426 1.8373 1.528 3.1026 2.0186.9494.372 2.3774.8067 5.008.932 2.844.1254 3.6934.1574 10.8987.1574 7.212 0 8.0547-.032 10.8987-.1574 2.6306-.1253 4.0653-.56 5.0146-.932 1.2587-.4906 2.1587-1.076 3.0974-2.0186.9493-.944 1.5346-1.8387 2.0253-3.096.3653-.9574.8053-2.3854.9253-5.016.132-2.844.164-3.6934.164-10.9054 0-7.1973-.032-8.0533-.164-10.8973zm4.8574 22.024c-.132 2.8747-.5854 4.8387-1.2587 6.5493-.6853 1.7747-1.604 3.2787-3.108 4.7827-1.4973 1.4973-3.0013 2.416-4.776 3.1093-1.7173.6667-3.6747 1.1254-6.5507 1.2507-2.876.1387-3.7946.164-11.1253.164-7.324 0-8.2493-.0253-11.1253-.164-2.8694-.1253-4.8254-.584-6.5507-1.2507-1.768-.6933-3.272-1.612-4.7693-3.1093-1.504-1.504-2.4227-3.008-3.1147-4.7827C.7493 42.9867.296 41.0227.1573 38.148.032 35.272 0 34.352 0 27.0213c0-7.324.032-8.2426.1573-11.1186.1387-2.8694.592-4.832 1.2587-6.5507.692-1.768 1.6107-3.2787 3.1147-4.776C6.028 3.0787 7.532 2.1533 9.3 1.4613c1.7253-.6666 3.6813-1.12 6.5507-1.252 2.876-.132 3.8013-.164 11.1253-.164 7.3307 0 8.2493.032 11.1253.164 2.876.132 4.8334.5854 6.5507 1.252 1.7747.692 3.2787 1.6174 4.776 3.1147 1.504 1.4973 2.4227 3.008 3.108 4.776.6733 1.7187 1.1267 3.6813 1.2587 6.5507.132 2.876.164 3.7946.164 11.1186 0 7.3307-.032 8.2507-.164 11.1267z"
                    fill="url(#e)"
                    transform="matrix(1 0 0 -1 0 54.004)"
                  />
                  <path
                    d="M13.9093 4.9693c-4.964 0-8.992 4.0214-8.992 8.9854 0 4.972 4.028 8.9986 8.992 8.9986 4.9654 0 8.9987-4.0266 8.9987-8.9986 0-4.964-4.0333-8.9854-8.9987-8.9854zm0 22.848C6.2573 27.8173.06 21.6067.06 13.9547.06 6.3093 6.2573.1053 13.9093.1053c7.652 0 13.856 6.204 13.856 13.8494 0 7.652-6.204 13.8626-13.856 13.8626z"
                    fill="url(#f)"
                    transform="matrix(1 0 0 -1 13.0667 40.9373)"
                  />
                </g>
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="17.5"
                width="17.5"
                viewBox="-100.7682 -167.947 873.3244 1007.682"
                className="absolute"
              >
                <g fill="#00000">
                  <path d="M335.895 0c-91.224 0-102.663.387-138.49 2.021-35.752 1.631-60.169 7.31-81.535 15.612-22.088 8.584-40.82 20.07-59.493 38.743-18.674 18.673-30.16 37.407-38.743 59.495C9.33 137.236 3.653 161.653 2.02 197.405.386 233.232 0 244.671 0 335.895c0 91.222.386 102.661 2.02 138.488 1.633 35.752 7.31 60.169 15.614 81.534 8.584 22.088 20.07 40.82 38.743 59.495 18.674 18.673 37.405 30.159 59.493 38.743 21.366 8.302 45.783 13.98 81.535 15.612 35.827 1.634 47.266 2.021 138.49 2.021 91.222 0 102.661-.387 138.488-2.021 35.752-1.631 60.169-7.31 81.534-15.612 22.088-8.584 40.82-20.07 59.495-38.743 18.673-18.675 30.159-37.407 38.743-59.495 8.302-21.365 13.981-45.782 15.612-81.534 1.634-35.827 2.021-47.266 2.021-138.488 0-91.224-.387-102.663-2.021-138.49-1.631-35.752-7.31-60.169-15.612-81.534-8.584-22.088-20.07-40.822-38.743-59.495-18.675-18.673-37.407-30.159-59.495-38.743-21.365-8.302-45.782-13.981-81.534-15.612C438.556.387 427.117 0 335.895 0zm0 60.521c89.686 0 100.31.343 135.729 1.959 32.75 1.493 50.535 6.965 62.37 11.565 15.68 6.094 26.869 13.372 38.622 25.126 11.755 11.754 19.033 22.944 25.127 38.622 4.6 11.836 10.072 29.622 11.565 62.371 1.616 35.419 1.959 46.043 1.959 135.73 0 89.687-.343 100.311-1.959 135.73-1.493 32.75-6.965 50.535-11.565 62.37-6.094 15.68-13.372 26.869-25.127 38.622-11.753 11.755-22.943 19.033-38.621 25.127-11.836 4.6-29.622 10.072-62.371 11.565-35.413 1.616-46.036 1.959-135.73 1.959-89.694 0-100.315-.343-135.73-1.96-32.75-1.492-50.535-6.964-62.37-11.564-15.68-6.094-26.869-13.372-38.622-25.127-11.754-11.753-19.033-22.943-25.127-38.621-4.6-11.836-10.071-29.622-11.565-62.371-1.616-35.419-1.959-46.043-1.959-135.73 0-89.687.343-100.311 1.959-135.73 1.494-32.75 6.965-50.535 11.565-62.37 6.094-15.68 13.373-26.869 25.126-38.622 11.754-11.755 22.944-19.033 38.622-25.127 11.836-4.6 29.622-10.072 62.371-11.565 35.419-1.616 46.043-1.959 135.73-1.959" />
                  <path d="M335.895 447.859c-61.838 0-111.966-50.128-111.966-111.964 0-61.838 50.128-111.966 111.966-111.966 61.836 0 111.964 50.128 111.964 111.966 0 61.836-50.128 111.964-111.964 111.964zm0-284.451c-95.263 0-172.487 77.224-172.487 172.487 0 95.261 77.224 172.485 172.487 172.485 95.261 0 172.485-77.224 172.485-172.485 0-95.263-77.224-172.487-172.485-172.487m219.608-6.815c0 22.262-18.047 40.307-40.308 40.307-22.26 0-40.307-18.045-40.307-40.307 0-22.261 18.047-40.308 40.307-40.308 22.261 0 40.308 18.047 40.308 40.308" />
                </g>
              </svg>
            </a>
          </div>

          <div className="text-gray-800 dark:text-gray-300 pb-8 ">
            <div className="mb-6">
              <div className="font-semibold">© 2025 Copyright: OMMC™</div>

              <p className="  text-xs flex justify-left mt-2 mb-3 ">
                Made by Kevin Liu for OMMC
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
